/**
 * Phil platform — shared types and UI constants.
 *
 * The form schema (sections + questions) is served by the backend at
 * GET /api/application/schema and is no longer duplicated here.
 * Update backend/app/phil_data.py each cycle to change questions or options.
 */

export type FieldType =
  | 'text'
  | 'textarea'
  | 'number'
  | 'currency'
  | 'select'
  | 'checkboxes'
  | 'file'
  | 'video'
  | 'link';

export interface Question {
  id: number;
  label: string;
  type: FieldType;
  required?: boolean;
  options?: string[];
  placeholder?: string;
  note?: string;
  hint?: string;
  pattern?: string;
  patternHint?: string;
  searchable?: boolean; // select-only: render as a type-to-filter combobox
  groupThousands?: boolean; // number-only: display the answer with thousands separators
}

export interface FormSection {
  id: string;
  index: number;
  title: string;
  shortLabel: string;
  questionCount: number;
  questions: Question[];
}

export const STATUS_BADGE: Record<string, string> = {
  'Due Fri': 'phil-badge phil-badge-review',
  Pending: 'phil-badge phil-badge-submitted',
  Open: 'phil-badge phil-badge-new',
  Later: 'phil-badge phil-badge-draft',
  Complete: 'phil-badge phil-badge-complete',
};
